import { type FC } from 'react';
import { Stack } from '@mantine/core';
import { useUnit } from 'effector-react';
import { Filters, $filters, OrdersList } from './components';
import { paginationModel } from './model';

export const Processing: FC = () => {
    const { filters } = useUnit({
        filters: $filters,
    });

    return (
        <Stack gap='md'>
            <Stack gap='sm'>
                <Filters onReset={paginationModel.reset} />

                <OrdersList
                    isPollingEnabled
                    filters={filters}
                    paginationModel={paginationModel}
                />
            </Stack>
        </Stack>
    );
};
